
export const OPEN_MODAL_CONFIRM = "OPEN_MODAL_CONFIRM"

export function dispatchModalConfirm(param) {
    return { 
            type: param.type,
            payload: param.payload
    }
}